import { createFileRoute } from '@tanstack/react-router'
import { SymbalismPage } from '@/pages/Symbalism/SymbalismPage'

export const Route = createFileRoute('/symbalism/')({
  component: SymbalismPageRoute,
  head: () => ({
    meta: [
      {
        title: 'Symbalism - Copshop',
      },
      {
        name: 'description',
        content: 'Hand-drawn spiral animation.',
      },
    ],
  }),
})

function SymbalismPageRoute() {
  return <SymbalismPage />
}
